import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { FooterComponentLayout } from '../../../../shared/components/footer/footer.component';
import { WizardMenuComponent } from '../../components/wizard-menu/wizard-menu.component';
import { ImpersonationHeaderComponent } from '../../../../shared/components/impersonation-header/impersonation-header.component';
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';

@Component({
    selector: 'app-wizard-layout',
    imports: [CommonModule, RouterOutlet, HeaderComponent, FooterComponentLayout, WizardMenuComponent, ImpersonationHeaderComponent, LoaderComponent],
    templateUrl: './wizard-layout.component.html',
    styleUrl: './wizard-layout.component.scss'
})
export class WizardLayoutComponent implements OnInit {
  isMobile = false;
  userName!: string;
  impersonatedUser!: string;
  activeStepIndex = 0;

  steps = [
    { 
      title: 'Dentist information', 
      description: 'Information for identification',
      route: '/credentialing/information',
      stepNumber: 1
    },
    { 
      title: 'Dental credentials', 
      description: 'Licenses, certifications and qualifications',
      route: '/credentialing/credentials',
      stepNumber: 2
    },
    { 
      title: 'Work/Education history', 
      description: 'Work or School information', 
      route: '/credentialing/work-history' ,
      stepNumber: 3
    },
    { 
      title: 'Attestations', 
      description: 'Attest and sign professional information', 
      route: '/credentialing/attestations',
      stepNumber: 4
    },
    { 
      title: 'Locations', 
      description: 'Manage participating locations', 
      route: '/credentialing/locations' ,
      stepNumber: 5
    },
    { 
      title: 'Documents', 
      description: 'Sign all applicable documentation',
      route: '/credentialing/sign-documents',
      stepNumber: 6
    },
    { 
      title: 'Confirmation', 
      description: 'Verify and submit credentialing application',
      route: '/credentialing/confirmation' ,
      stepNumber: 7
    }
  ];

  constructor(private router: Router) {}

  ngOnInit() {
    this.checkScreenSize();
    this.impersonatedUser = localStorage.getItem("impersonatedUser") ?? ""
    this.userName = localStorage.getItem("userName") ?? ""
    
    this.updateActiveStep(this.router.url);
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.updateActiveStep(event.url);
    });
  }

  private updateActiveStep(url: string) {
    const index = this.steps.findIndex(s => url.includes(s.route.split('/').pop()!));
    this.activeStepIndex = index >= 0 ? index : 0;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isMobile = window.innerWidth < 1024;
  }
  goBack(){
    this.router.navigate(['/landing']);
  }

  toggleStep(index: number) {
    const step = this.steps[index];
    if (step && this.router.url !== step.route) {
      this.router.navigate([step.route]);
    }
  }

  isStepCompleted(index: number): boolean {
    return this.activeStepIndex > index;
  }
}